import { getFormData } from "../../../common";
import { createLivingArea } from "../../../repository/RealEstateRepository";

const LivingAreaCreate = (props) => {

  const onSubmit = (e) => {
    e.preventDefault();
    const Toast = window.Toast;
    const formData = getFormData(e.target);
    createLivingArea(formData, () => {
      e.target.name.value = '';
      Toast.info("LIVING AREA ADDED!");
    });
  };

  return (<>
    <form action="/" onSubmit={onSubmit}>
      <div className="row">
        <div className="col-0 col-sm-3"></div>
        <div className="col-12 col-sm-6 form-group text-left">
          <div>Front Yard</div>
          <select name="frontYardId" className="custom-select">
            {props.frontYards.map((v, i) => (
              <option key={i} value={v.id}>{v.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-0 col-sm-3"></div>
        <div className="col-12 col-sm-6 form-group text-left">
          <label>Name</label>
          <input name="name" className="form-control fluid" />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <button type="submit" className="btn btn-primary">Create</button>
        </div>
      </div>
    </form>
  </>);
};

export { LivingAreaCreate };
